export default "__VITE_ASSET__DFJJAH4Q__"